import React, { useRef, useState } from 'react'
import { useMyContext } from '../../../../components/Provider/CommonProvider';
import AdminSaveHeader from '../../../../components/CommonComponents/AdminSaveHeader';
import Defaultloadinggif from '../../../../layout/Others/Defaultloadinggif';
import { toast } from 'react-toastify';
import FormContainer from '../../../../components/CommonComponents/FormContainer';
import LeftWrapper from '../../../../components/CommonComponents/LeftWrapper';
import MessageHeading from '../../../../components/CommonComponents/MessageHeading';
import Wrapper from '../../../../components/CommonComponents/Wrapper';
import MessageSubHeading from '../../../../components/CommonComponents/MessageSubHeading';
import { Link } from 'react-router-dom';
import { BiLinkExternal } from 'react-icons/bi';
import MessageLabel from '../../../../components/CommonComponents/MessageLabel';
import AdminCustomSelect from '../../../../components/CommonComponents/AdminCustomSelect';
import RightWrapper from '../../../../components/CommonComponents/RightWrapper';
import AdminCustomInput from '../../../../components/CommonComponents/AdminCustomInput';
import AdminBackNavigation from '../../../../components/CommonComponents/AdminBackNavigation';
import DeviceSelector from '../../../../components/PaymentComponents/DeviceSelector';
import Response_Processing from '../../../../layout/Others/Response_Processing';

const Pesapal = () => {
    const baseUrl = process.env.REACT_APP_Baseurl;
    const indexApi = `${baseUrl}/admin/pesapal_payment/index`
    const storeApi = `${baseUrl}/admin/pesapal_payment/store`

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true);
    const [showOverlay, setShowOverlay] = useState(false)
    const [formDataError, setFormDataError] = useState({})

    // Supported devices from backend helper
    const [supportedDevices, setSupportedDevices] = useState(['web', 'Android', 'iOS', 'TV']);

    const { fetchRequest } = useMyContext()
    const combinedRef = useRef({});

    const handleInput = (e) => {
        const { value, name, type } = e.target;

        if (type === 'text') {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }))
        }

        if (type === 'select-one') {
            setFormData(prev => ({
                ...prev,
                payment_mode: value
            }))

            if (formData?.payment_mode == 1) {
                setFormDataError(prev => ({
                    ...prev,
                    live_consumer_key: '',
                    live_consumer_secret: '',
                }))
            } else {
                setFormDataError(prev => ({
                    ...prev,
                    sandbox_consumer_key: '',
                    sandbox_consumer_secret: ''
                }))
            }

            setFormDataError(prev => ({
                ...prev,
                [name]: ''
            }))
        }

        if (type === 'text') {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }))
            setFormDataError(prev => ({
                ...prev,
                [name]: ''
            }))
        }
    }

    const handleDeviceChange = (updatedDevices) => {
        // Filter only valid devices and ensure it's an array
        const validDevices = Array.isArray(updatedDevices)
            ? updatedDevices.filter(device => supportedDevices.includes(device))
            : [];

        console.log('Pesapal Device change:', { updatedDevices, validDevices, supportedDevices });

        setFormData((prev) => ({
            ...prev,
            supported_devices: validDevices
        }));
    };

    const formValidation = () => {
        let isFormValid = true;

        // Validate supported devices
        if (!formData?.supported_devices || !Array.isArray(formData.supported_devices) || formData.supported_devices.length === 0) {
            toast.warning('Please select at least one supported device.');
            isFormValid = false;
        }

        if (formData?.payment_mode == 1 && !formData?.live_consumer_key) {
            setFormDataError(prev => ({
                ...prev,
                live_consumer_key: "Live Consumer Key can not be empty"
            }))
            combinedRef.current['live_consumer_key'].focus()
            isFormValid = false
        }
        if (formData?.payment_mode == 1 && !formData?.live_consumer_secret) {
            setFormDataError(prev => ({
                ...prev,
                live_consumer_secret: "Live Secret Key can not be empty"
            }))
            combinedRef.current['live_consumer_secret'].focus()
            isFormValid = false
        }
        if (formData?.payment_mode == 0 && !formData?.sandbox_consumer_key) {
            setFormDataError(prev => ({
                ...prev,
                sandbox_consumer_key: "Sandbox Consumer Key can not be empty"
            }))
            combinedRef.current['sandbox_consumer_key'].focus()
            isFormValid = false
        }
        if (formData?.payment_mode == 0 && !formData?.sandbox_consumer_secret) {
            setFormDataError(prev => ({
                ...prev,
                sandbox_consumer_secret: "Sandbox Secret Key can not be empty"
            }))
            combinedRef.current['sandbox_consumer_secret'].focus()
            isFormValid = false
        }
        return isFormValid;
    }

    const handleStore = async () => {
        console.log('Pesapal Form data before validation:', formData);
        if (formValidation()) {
            setShowOverlay(true)
            const dataToSend = {
                ...formData,
                supported_devices: JSON.stringify(formData.supported_devices || [])
            };
            console.log('Pesapal Data being sent:', dataToSend);
            try {
                const result = await fetchRequest({
                    method: 'POST',
                    url: `${storeApi}`,
                    data: dataToSend
                })

                if (result?.status) {
                    toast.success(result?.message)
                    setShowOverlay(false)
                }
            } catch (error) {
                toast.error(error?.result?.message)
            }
        }

    }

    const fetchData = async () => {
        setLoading(true)

        // Fetch supported devices from backend
        try {
            const deviceResponse = await fetchRequest({
                method: 'GET',
                url: `${process.env.REACT_APP_Baseurl}/admin/supported-devices`,
                data: {},
            });
            if (deviceResponse?.status && deviceResponse?.data) {
                setSupportedDevices(deviceResponse.data);
            }
        } catch (error) {
            console.warn('Using default supported devices:', error);
        }

        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${indexApi}`,
                data: {}
            })

            if (response?.status) {
                const pesapalData = response?.pasapal_payment;
                let deviceArray = []; // default

                // Parse supported_devices if it exists
                if (pesapalData?.supported_devices) {
                    try {
                        const parsedDevices = typeof pesapalData.supported_devices === 'string'
                            ? JSON.parse(pesapalData.supported_devices)
                            : pesapalData.supported_devices;
                        deviceArray = Array.isArray(parsedDevices) ? parsedDevices : [];
                        console.log('Pesapal Loaded devices:', deviceArray);
                    } catch (error) {
                        console.warn('Invalid supported_devices format:', pesapalData.supported_devices);
                        deviceArray = [];
                    }
                }

                setFormData(prev => ({
                    ...prev,
                    ...pesapalData,
                    supported_devices: deviceArray
                }))
                setLoading(false)
            }

        } catch (error) {

        }
    }

    useState(() => {
        fetchData()
    }, [])

    if (loading) return <Defaultloadinggif className={"heightOnLoader"} />

    return (
        <>
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation id="playout-backbtn" path="/payment_settings" text="Back" />
            <AdminSaveHeader heading={"Pesapal payment"} saveMethod={handleStore} saveText={"Update"} />

            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={"Pesapal Configuration"} />
                        <Link to="https://developer.pesapal.com/how-to-integrate/e-commerce/api-30-json/api-reference/" target="_blank" className="d-inline-flex  align-items-center gap-2 p-2 rounded-2 shadow mb-4">
                            <MessageSubHeading text="https://pesapal.com/docs" noMargin />
                            <BiLinkExternal className="text-dark ms-2" />
                        </Link>
                        <FormContainer className={`justify-content-between align-items-center`}>
                            <div className={`col-7`}>
                                <MessageLabel text={"Enable Payment Mode"} />
                            </div>
                            <div className={`col-3`}>
                                <AdminCustomSelect name="payment_mode" value={formData?.payment_mode} onChange={handleInput} ref={(el) => (combinedRef.current.payment_mode = el)} options={[{ name: "TEST", value: 0 }, { name: "LIVE", value: 1 }]} error={""} defaultOptionName={""} />
                            </div>
                        </FormContainer>
                        <MessageLabel text={"Pesapal Label"} />
                        <AdminCustomInput name="pesapal_label" value={formData?.pesapal_label} onChange={handleInput} placeHolder={`pesabel label`} />
                    </Wrapper>
                    <Wrapper>
                        <DeviceSelector
                            selectedDevices={formData?.supported_devices || []}
                            onDeviceChange={handleDeviceChange}
                            gatewayName="pesapal"
                            availableDevices={supportedDevices}
                            showDescriptions={true}
                            label="Supported Devices"
                            showSelectAll={true}
                            className=""
                            cardStyle="default"
                            showDeviceStats={true}
                        />
                    </Wrapper>
                </LeftWrapper>

                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={`Pesapal Key Details (Test)`} />
                        <MessageLabel text={`Sandbox consumer key`} />
                        <AdminCustomInput name="sandbox_consumer_key" value={formData?.sandbox_consumer_key} placeHolder={`Sandbox consumer key`} onChange={handleInput} error={formDataError?.sandbox_consumer_key} ref={(el) => { combinedRef.current.sandbox_consumer_key = el }} />
                        <MessageLabel text={`Sandbox consumer secret`} />
                        <AdminCustomInput name="sandbox_consumer_secret" value={formData?.sandbox_consumer_secret} placeHolder={`Sandbox consumer secret key`} onChange={handleInput} error={formDataError?.sandbox_consumer_secret} ref={(el) => { combinedRef.current.sandbox_consumer_secret = el }} />
                    </Wrapper>
                    <Wrapper>
                        <MessageHeading text={`Pesapal Key Details (Live)`} />
                        <MessageLabel text={`Live consumer key`} />
                        <AdminCustomInput name="live_consumer_key" value={formData?.live_consumer_key} placeHolder={`Live consumer key`} onChange={handleInput} error={formDataError?.live_consumer_key} ref={(el) => { combinedRef.current.live_consumer_key = el }} />
                        <MessageLabel text={`Live consumer secret key`} />
                        <AdminCustomInput name="live_consumer_secret" value={formData?.live_consumer_secret} placeHolder={`Live consumer secret key`} onChange={handleInput} error={formDataError?.live_consumer_secret} ref={(el) => { combinedRef.current.live_consumer_secret = el }} />
                    </Wrapper>
                </RightWrapper>
            </FormContainer>

        </>
    )
}

export default Pesapal